import { SetInveriteCredentialsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useSetInveriteCredentials() {
  const [saving, setSaving] = useState(false);

  async function setInveriteCredentials(request: SetInveriteCredentialsRequest) {
    try {
      setSaving(true);
      const res = await api.postSetInveriteCredentials(request);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSaving(false);
    }
  }

  return { saving, setInveriteCredentials };
}
